export default __webpack_public_path__ + "static/media/gdpr-logo.15b028f1.svg";